<template>
  <img :src="src" :alt="alt" :class="{hide: !show}" />
</template>

<script>
export default {
  name: "MenubarLogo",
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  position: fixed;
  top: 0;
  height: $menubar-height;
  transition-property: all;
  transition-duration: $menubar-transition-duration;
  transition-timing-function: $menubar-transition-timing-function;
  &.hide {
    height: $menubar-height/2;
  }
}
@media only screen and (max-width: $mobile-width) {
  img {
    position: absolute;
    height: $menubar-height/2;
    &.hide {
      margin-top: $menubar-height/-2;
    }
  }
}
</style>
